import { render, staticRenderFns } from "./AgenPage.vue?vue&type=template&id=58a7bd40&"
import script from "./AgenPage.vue?vue&type=script&lang=js&"
export * from "./AgenPage.vue?vue&type=script&lang=js&"
import style0 from "./AgenPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports